import styled, { css } from 'styled-components';
import { Typography } from '../../../../../ui/Typography';
import { FlexCenterAligned } from '../../../../../../styled/common';

export const ItemTitle = styled(Typography)`
  margin-right: 5px;
`;

export const ItemIcons = styled.span`
  svg {
    margin-top: -3px;
  }
`;

export const ItemDesc = styled(Typography)<{ $isLabeled: boolean }>`
  margin-top: 4px;
  ${({ $isLabeled }) => $isLabeled && 'padding-bottom: 22px;'}
`;

export const buttonStyles = css`
  width: 90px;
  height: 40px;
  border-radius: 20px;
`;

export const LabelContainer = styled(FlexCenterAligned)<{ $type: string }>`
  gap: 3px;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 5px;
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 0 7px;
  background-color: ${({ theme, $type }) =>
    $type === 'vip'
      ? theme.colors.promotion.vip
      : theme.colors.promotion.premium};
`;

export const LabelText = styled(Typography)`
  display: flex;
  gap: 3px;
  align-items: center;
  color: ${({ theme }) => theme.colors.text.white};

  &::before {
    content: '';
    display: block;
    width: 7px;
    height: 7px;
    background-image: url('/static/images/icon-plus--white.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;
